// Helper to parse utm_medium param from the URL
export const getUtmMediumQueryParam = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  return params['utm_medium'] || '';
};
